var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Label, Row, Col } from 'reactstrap';
import styles from './DefaultOrgUnitTemplateDialog.module.scss';
import { Modal } from '@app/Components/Modal/Modal';
import { ProjectTemplatePicker } from '@app/Components/Pickers/ProjectTemplatePicker/ProjectTemplatePicker';
export var DefaultOrgUnitTemplateDialog = /** @class */ (function (_super) {
    __extends(DefaultOrgUnitTemplateDialog, _super);
    function DefaultOrgUnitTemplateDialog(props) {
        var _this = _super.call(this, props) || this;
        _this._value = undefined;
        _this._handleSaveClick = function () {
            var onSave = _this.props.onSave;
            _this.props.orgUnitConfigurationModel.value = _this._value;
            onSave(_this.props.orgUnitConfigurationModel);
        };
        _this._handleChangeClick = function (value) {
            _this._value = value;
        };
        var orgUnitConfigurationModel = props.orgUnitConfigurationModel;
        _this._value = orgUnitConfigurationModel.value;
        return _this;
    }
    DefaultOrgUnitTemplateDialog.prototype.render = function () {
        var _a;
        var _this = this;
        var isOpen = (_a = this.props, _a.isOpen), onClose = _a.onClose, orgUnitConfigurationModel = _a.orgUnitConfigurationModel;
        return (React.createElement(Modal, { isOpen: isOpen, minWidth: "1100px", toggle: onClose, headerTitle: orgUnitConfigurationModel.orgUnitDisplayName, footerbuttons: this._getFooterButtons() },
            React.createElement(React.Fragment, null,
                React.createElement(Row, { className: styles.row },
                    React.createElement(Col, { sm: "3" },
                        React.createElement(Label, null, "Template")),
                    React.createElement(Col, null,
                        React.createElement(ProjectTemplatePicker, { isClearable: true, defaultValue: this._value, onChangeHandler: function (ou) { var _a; return _this._handleChangeClick((_a = ou === null || ou === void 0 ? void 0 : ou.value) !== null && _a !== void 0 ? _a : ''); } }))))));
    };
    DefaultOrgUnitTemplateDialog.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._handleSaveClick,
                title: 'Save'
            },
            {
                onClick: this.props.onClose,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], DefaultOrgUnitTemplateDialog.prototype, "_value", void 0);
    __decorate([
        action.bound
    ], DefaultOrgUnitTemplateDialog.prototype, "_handleSaveClick", void 0);
    __decorate([
        action.bound
    ], DefaultOrgUnitTemplateDialog.prototype, "_handleChangeClick", void 0);
    DefaultOrgUnitTemplateDialog = __decorate([
        observer
    ], DefaultOrgUnitTemplateDialog);
    return DefaultOrgUnitTemplateDialog;
}(React.Component));
